module.exports = {
  CONTENT: {
    SUBHEADER: {
      city: 'Cachoeiro de Itapemirim',
      color: '#10c39c',
      procuracao: ''
    },
    APP: {
      name: 'Cachoeiro Online'
    },
    HEADER: {
      title: 'Bem vindo a sua Unidade de Saúde Online',
      titleLogged: 'Olá, ',
      subtitle: 'Agende os serviços disponíveis em uma Unidade de Saúde da Prefeitura de Cachoeiro de Itapemirim. Siga o passo a passo e leia com atenção todas as informações.',
    },
    STEPPER: {
      ONE: {
        title: 'Categoria',
        description: 'Selecione a categoria na qual deseja marcar um serviço',
      },
      TWO: {
        title: 'Serviços',
        description: 'Selecione o serviço e os detalhes do atendimento',
      },
      THREE: {
        title: 'Insira os dados',
        description: 'Insira os dados necessários para prosseguir',
      },
      FOUR: {
        title: 'Dados do agendamento',
        description: 'Escolha a data e o horário desejados.',
      },
      FIVE: {
        title: 'Confirmação',
        description: 'Confira seus dados e confirme o seu atendimento',
      },
    },
    HOME: {
      SEARCHBANNER: {
        title: 'Procon de Cachoeiro de Itapemirim',
      },
      BANNERAPP: {
        title: 'EXPERIMENTE NOSSO APP',
        city: 'prefeitura Cachoeiro de Itapemirim'
      },
      INFOCARDS: {
        FIRST: {
          title: 'LISTA DE UNIDADES',
          description: 'Encontre informações de localização e contato das Unidades de Saúde do seu município.',
          buttonLabel: 'SAIBA MAIS',
        },
        SECOND: {
          title: 'VALIDAÇÃO DE CADASTRO',
          description: 'Após o cadastro seus dados são validados pela UBS e seu acesso é liberado em algumas horas.',
          buttonLabel: 'SAIBA MAIS',
        },
        THIRD: {
          title: 'DÚVIDAS FREQUENTES',
          description: 'Confira as dúvidas mais frequentes e veja dicas e soluções que preparamos para te auxiliar.',
          buttonLabel: 'SAIBA MAIS',
        }
      },
      SERVICES: {
        atendimento: 'https://agendamento.cachoeiro.es.gov.br/agendamento/',
        chamado: 'https://ouvidoria.cachoeiro.es.gov.br/categorias/',
        negociacao: '',
        reclamacao: '/reclamacao-online',
      },
      SURVEYBANNER: {
        title: 'Dê sua opinião!',
        subtitle: 'Sugestões de como podemos melhorar a experiência do site? Mande para a gente.',
      },
      OTHERS: {
        LINKS: {
          googlePlay: 'https://prml.me/JIVY',
          appleStore: 'https://prml.me/JJs7',
        }
      },
    },
    HIGHLIGHTS: {
      FIRST: {
        title: 'Código de defesa do consumidor',
        description: 'O Código de Defesa protege e ampara você como consumidor. Saiba mais sobre seus direitos.',
        href: '/codigo-defesa-consumidor',
      },
      SECOND: {
        title: 'Dúvidas sobre o sistema?',
        description: 'Veja as dúvidas mais frequentes sobre o Procon online.',
        href: '/faq',
      },
      THIRD: {
        title: 'Mantenha seu cadastro atualizado',
        description: 'Isso garante seu acesso aos serviços oferecidos pelo Procon.',
        href: `${process.env.VUE_APP_MINHACONTA_ROUTE}/profile/information`
      },
      APPOINTMENT: {
        title: 'Marcar agendamento',
        description: 'Obtenha atendimento pessoal no Procon para resolver questões sobre seus direitos',
        href: '/agendamento/servico'
      },
      CONSULT: {
        title: 'Meus agendamentos',
        description: 'Confira os detalhes dos seus agendamentos realizados',
        href: '/agendamento/consulta'
      },
      MANIFESTATION: {
        title: 'Abrir chamado',
        description: 'Faça uma denúncia sobre um fornecedor que violou seus direitos como consumidor',
        href: '/denuncia/servico'
      },
      MYMANIFESTATIONS: {
        title: 'Meus chamados',
        description: 'Veja o andamento dos seus chamados pelo número de protocolo ou login',
        href: '/denuncia/solicitacoes'
      },
    },
    FOOTER: {
      ABOUT: {
        first: 'Sobre o Procon',
        second: 'Dúvidas',
      },
      MENU: {
        first: 'Reclamação',
        second: 'Minhas reclamações',
        third: 'Dúvidas',
      },
      CONTACT: {
        title: 'Em caso de dúvidas:',
        tel: '(28) 98814-3357',
        telLabel: 'Munícipe',
        secondTel: '(28) 3199-1710',
        secondTelLabel: 'Segunda à sexta, de 08:00 às 17:00',
        email: 'ouvidoria@cachoeiro.es.gov.br',
        emailLabel: 'Email geral',
        address: '',
        mapsUrl: ''
      },
      ICONS: {
        LINKS: {
          facebook: 'https://www.facebook.com/prefcachoeiro/',
          linkedin: 'https://www.linkedin.com/company/prefeitura-municipal-de-cachoeiro-de-itapemirim/',
          instagram: 'https://www.instagram.com/prefcachoeiro/',
          youtube: 'https://www.youtube.com/user/semcoscachoeiro',
        }
      }
    },
    AUTOCOMPLETE: {
      LOCATION: {
        lat: '-20.8494',
        lng: '-41.1132',
      },
      addressError: 'São permitidos apenas endereços da cidade de Cachoeiro'
    },
    FAQ: {
      faqItems: [
        {
          id: 0,
          question: 'Como funciona o Procon online?',
          answer: 'O consumidor realiza todo o processo de forma 100% online, através do computador ou celular. É possível abrir e acompanhar reclamações, formalizar denúncias, realizar agendamentos para atendimentos presenciais.'
        },
        {
          id: 1,
          question: 'Como funciona o login único?',
          answer: 'O login único é uma forma de acesso simplicado a várias funcionalidades da plataforma da sua cidade. Nele você acessa vários serviços com um mesmo e-mail e senha previamente cadastrados. ',
          link: {
            text: 'login único',
            ref: 'https://minhaconta-cachoeiro.upcities.app',
          }
        },
        {
          id: 2,
          question: 'Como faço para abrir uma reclamação?',
          answer: 'As reclamações podem ser feitas presencialmente ou de forma online. Antes de abrir uma reclamação no Procon, é importante que o consumidor entre em contato com o fornecedor para buscar a resolução do problema. Não tendo sucesso e sendo necessária a intervenção do Procon, de forma online, você vai precisar inicialmente realizar o seu cadastro.',
        },
        {
          id: 3,
          question: 'Quais os documentos necessários para abrir uma reclamação?',
          answer: '&#8226; Documento de identificação oficial com foto\n&#8226; Comprovante de residência\n&#8226; CPF\n&#8226; Nota Fiscal\n&#8226; Contrato de prestação de serviço (se tiver)\n&#8226; Fatura (se for caso, por exemplo, de reclamação de cartão de crédito, água, energia elétrica, celular, telefone)\n&#8226; Ordem de Serviço (se se tratar de conserto)\n&#8226; Termo de garantia\n&#8226; Orçamento\n&#8226; Anexe imagens de mensagens de e-mail ou registros de qualquer contato que você teve com o empresa sobre a compra.'
        },
        {
          id: 4,
          question: 'O que é o pedido à empresa?',
          answer: 'O pedido se refere diretamente ao problema ao qual o consumidor esteja passando referente ao fato descrito. O pedido precisa expressar claramente o objetivo do consumidor, seja um esclarecimento, a apresentação de um documento, o encerramento do contrato, a conformidade do contrato com a entrega do produto ou a realização do serviço, a troca do produto ou devolução do valor pago, dentre outros.'
        },
        {
          id: 5,
          question: 'Quem pode abrir uma reclamação no Procon Municipal?',
          answer: 'O Procon presta atendimento a todo o consumidor que tenha qualquer problema ou dúvidas relacionadas ao Direito do Consumidor. Portanto, toda pessoa ou empresa que adquira ou use um produto ou serviço de um fornecedor e se sinta lesado, e resida no município do Procon, pode abrir uma reclamação.'
        },
        {
          id: 6,
          question: 'Posso abrir uma reclamação em nome de terceiro?',
          answer: 'Somente titulares da conta podem abrir uma reclamação.'
        },
        {
          id: 7,
          question: 'Como ver o andamento da minha reclamação?',
          answer: 'No Procon online você acompanha todas as atualizações através da plataforma web ou aplicativo em ‘minhas reclamações’. A cada atualização você também é notificado via e-mail e notificação no seu celular.'
        },
        {
          id: 8,
          question: 'Como realizar uma denúncia?',
          answer: 'As denúncias são realizadas na Ouvidoria, presencialmente no Procon, ou através da plataforma Procon Online.'
        },
        {
          id: 9,
          question: 'Qual a diferença entre reclamação e denúncia?',
          answer: 'A reclamação se refere a algo específico que tenha ocorrido com o consumidor. Já a denúncia se refere a algo que afete a coletividade.'
        },
        {
          id: 10,
          question: 'Como posso pedir orientações para tirar dúvidas com o Procon?',
          answer: 'Através de nossos atendimentos presenciais ou entrando em contato conosco pelo telefone (27) 3199-1710. O Procon realiza atendimentos presenciais, e você também pode agendar seu atendimento.',
        }
      ],
    },
    BREADCRUMB: {
      RECLAMATION: {
        index: 'Abrir reclamação',
        onlineRelation: 'Reclamação Online',
        finish: 'Reclamação realizada',
      },
      MYCOMPLAINTS: {
        index: 'Minhas reclamações',
        onlineRelation: 'Reclamação Online',
        details: 'Detalhes da reclamação'
      },
      CONSUMER: {
        index: 'Código de defesa do consumidor',
        audio: 'Código de defesa em áudio'
      },
      RANKING: {
        index: 'Ranking das reclamações'
      },
      PRICE: {
        index: 'Pesquisa de preços',
        details: 'Detalhes da pesquisa'
      },
      MANIFESTATION: {
        title: 'Chamado',
        service: 'Serviço',
        create: 'Abrir solicitação',
        confirm: 'Confirmar solicitação',
        list: 'Minhas solicitações'
      },
      APPOINTMENT: {
        title: 'Agendamento',
      }
    },
    COMPLAINT_RANKING: {
      title: 'Históricos de reclamações',
      description: 'Acompanhe o histórico de reclamações de todas as empresas registradas no Procon Cachoeiro de Itapemirim',
      icon: 'WomanHeadache',
      bgIcon: 'BannerRedirectBg',
      href: 'Home',
      bgColor: '#f8e7e7'
    },
    MESSAGE: {
      MANIFESTATION: {
        noTicketFirst: 'Você não possui nenhuma solicitação registrada.',
        noTicketSecond: 'Caso deseje abrir uma nova solicitação, por favor',
      }
    },
    // BOT: {
    //   name: 'Procon Cachoeiro de Itapemirim',
    //   id: 'proconpmvv',
    //   url: 'https://proconpmvv.getupbots.com',
    //   color: '105ba6',
    // },
    FILE: {
      //Before changing maxsize check with backend the maximum accepted size!
      maxSize: '5',
      images: 'São permitidos uploads de arquivos com as seguintes extensões:  jpg, png ou jpeg',
      imagesAndPDF: 'São permitidos uploads de arquivos com as seguintes extensões:  jpg, png, jpeg ou pdf'
    },
    POLICY: {
      text: 'Esta página do site da Prefeitura de Cachoeiro de Itapemirim usa Cookies Operacionais de Sessão para o funcionamento do sistema, que podem armazenar seus dados pessoais indiretamente. Conforme detalhado no AVISO DE PRIVACIDADE e de acordo com o Art. 5 da LGPD (Lei 13.709/2018) solicitamos seu CONSENTIMENTO para prosseguir. Sua rejeição pode implicar no não funcionamento das tecnologias do site. Você aceita os Cookies de Sessão?',
      ref: 'https://upcities.app/politica-privacidade-cachoeiro-itapemirim',
    },
  }
};
